import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';

import { AppRoutingModule} from './app.router';
import { AppComponent } from './app.component';
import { DefaultComponent } from './default/default.component';
import { ArticuloComponent } from './articulo/articulo.component';
import { NotasComponent } from './articulo/notas/notas.component';
import { CommentsComponent } from './articulo/notas/comments/comments.component';
import { EditorialsComponent } from './articulo/notas/editorials/editorials.component';
import { SidebarComponent } from './articulo/sidebar/sidebar.component';
import { HighlightPipe } from './pipes/highlight.pipe';

@NgModule({
  declarations: [
    AppComponent,
    DefaultComponent,
    ArticuloComponent,
    NotasComponent,
    CommentsComponent,
    EditorialsComponent,
    SidebarComponent,
    HighlightPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/app.module.ts